import {useEffect, useState} from "react";
import {useNavigate} from "react-router";
import ModalCustom from "./ModalCustom";
import {ACCESSORIES_STOCK_PATH} from "../../../constants/RoutesPaths";
import {useEventProvider} from "../../../providers/EventProvider.tsx";

export const StockAccessoriesNotification = () => {
    const [showModal, setShowModal] = useState(false);
    const {accessoriesNotifications} = useEventProvider();
    const navigate = useNavigate();

    useEffect(() => {
        if (accessoriesNotifications.data) {
            setShowModal(true);
        }
    }, [accessoriesNotifications]);

    function handleSee() {
        navigate(ACCESSORIES_STOCK_PATH);
    }

    return (
        <>
            <ModalCustom
                show={showModal}
                id={'stockAccessoriesModal'}
                onHide={() => setShowModal(false)}
                content={
                    <>
                        <h5>N'oubliez pas d’actualiser la liste des accessoires disponibles dans votre boutique.</h5>
                    </>
                }
                bodyClassname={'m-3'}
                backdrop={'static'}
                footer={true}
                buttonsFooter={[
                    {
                        text: 'Fermer',
                        func: () => setShowModal(false),
                    },
                    {
                        text: 'Voir',
                        func: () => handleSee(),
                    }
                ]}
            />
        </>
    );
}